module.exports = __webpack_public_path__ + "img/Prog-outline-online-v3.9359a578.svg";